(function ($) {
    $(() => {


        if ($('.wheel-video').length) {

            window.onbeforeunload = function () {
                window.scrollTo(0, 0);
            }

            $('body').addClass('no-scroll');


            if (window.innerWidth > 991) {
                document.getElementById('js-wheel-video').addEventListener('ended', myWheelVideoHandler, false);
            } else {
                document.getElementById('js-wheel-video-mobile').addEventListener('ended', myWheelVideoHandler, false);

            }

            function myWheelVideoHandler(e) {
                $('.js-video-wrapper').remove();
                $('.sustainability-wheel').addClass('active');
                $('body').removeClass('no-scroll');
                setTimeout(() => {
                    $('.js-anim-wheel').addClass('red-active').addClass('after-anim');
                    $('.js-text-red').addClass('active');
                }, 1800);

            }

            $('#js-skip-wheel-video').on('click', function (e) {
                e.preventDefault();

                var video = false;
                if (window.innerWidth > 991) {
                    video = document.getElementById("js-wheel-video");
                } else {
                    video = document.getElementById("js-wheel-video-mobile");

                }

                if (video) {
                    video.currentTime = video.duration;
                }
            })

            $('.js-clickable').on('click', function () {
                const oldClass = $('.js-clickable.active').data('class');
                const newClass = $(this).data('class');
                const color = $(this).data('color');

                $('.js-anim-wheel').removeClass(oldClass);
                $('.js-anim-wheel').addClass(newClass);

                $('.js-clickable').removeClass('active');
                $(this).addClass('active');

                $(`.js-text`).removeClass('active');
                $(`.js-text-${color}`).addClass('active');

            });
        }
    });
})(jQuery);